"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZapAbilityHandler = exports.ZapActorAbilityFactory = exports.ZapAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
class ZapAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Zap;
        this.__typeName = "Zap";
    }
}
exports.ZapAbilityArgs = ZapAbilityArgs;
let ZapActorAbilityFactory = class ZapActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Zap", "OneEnemies", 0);
    }
};
ZapActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Zap")
], ZapActorAbilityFactory);
exports.ZapActorAbilityFactory = ZapActorAbilityFactory;
let ZapAbilityHandler = class ZapAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 50)
            ],
            projectileType: "LightningBolt",
            projectilePath: "line"
        });
    }
};
ZapAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Zap)
], ZapAbilityHandler);
exports.ZapAbilityHandler = ZapAbilityHandler;
